// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Libraries
import { BehaviorSubject, takeUntil } from 'rxjs';

// Models
import { AppCleanup, JobStatusViewModel, LocationDto, LookUpResponse, LookUpViewModel, TenantDto } from '../models';
import { UnitTypeDto } from '../../modules/asset/unit/models/unit-type-dto.model';
import { JobScopeDto } from '../../modules/job/models/job-scope-dto.model';
import { JobAttachmentTypeViewModel } from '../../modules/job/models/job-attachment.model';
import { JobType, UnitType } from '../enums';
import { CompanyDto } from '../../modules/company/models/company-dto';
import { JobTypeDto } from '../../modules/job/components/daily-report/models/job-type-dto';
import { JobTypeChannelDto } from '../../modules/job/components/daily-report/models/job-type-channel-dto';

@Injectable({
	providedIn: 'root',
})
export class DataCachingService extends AppCleanup {
	protected dataReadyVar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	dataReady$ = this.dataReadyVar.asObservable();

	private lookUpUrl: string;
	lookUps: LookUpViewModel[] = [];
	stateAbbreviations: LookUpViewModel[] = [];
	jobStatuses: JobStatusViewModel[] = [];
	unitTypes: UnitTypeDto[] = [];
	jobTypes: JobTypeDto[] = [];
	jobTypeChannels: JobTypeChannelDto[] = [];
	jobScopes: JobScopeDto[] = [];
	jobAttachmentTypes: JobAttachmentTypeViewModel[] = [];
	tenants: TenantDto[] = [];
	companies: CompanyDto[] = [];
	locations: LocationDto[] = [];

	constructor(private http: HttpClient) {
		super();
		this.lookUpUrl = `${this.apiUrl}api/lookup`;
		this.refreshDataCache();
	}

	refreshDataCache(sendDataReadyVar: boolean = true) {
		this.getLookUps()
			.pipe(takeUntil(this.destroy))
			.subscribe((response) => {
				this.lookUps = response.lookUps;
				this.stateAbbreviations = this.lookUps.filter((lookup) => lookup.code === 'state');
				this.jobStatuses = response.jobStatuses;
				this.unitTypes = response.unitTypes;
				this.jobTypes = response.jobTypes;
				this.jobTypeChannels = response.jobTypeChannels;
				this.jobScopes = response.jobScopes;
				this.jobAttachmentTypes = response.jobAttachmentTypes;
				this.tenants = response.tenants;
				this.companies = response.companies;
				this.locations = response.locations;

				if (sendDataReadyVar) this.dataReadyVar.next(true);
			});
	}

	getLookUps(key?: string) {
		if (!key) {
			return this.http.get<LookUpResponse>(this.lookUpUrl);
		}
		return this.http.get<LookUpResponse>(`${this.lookUpUrl}?key=${key}`);
	}

	getUnitTypeAllowedJobTypes(unitType: UnitType | null | undefined): JobTypeDto[] {
		switch (unitType) {
			case UnitType.FacilityTest:
				return this.jobTypes.filter((jobType) => jobType.id === JobType.BopFacilityTest);
			default:
				return this.jobTypes;
		}
	}
}
